import { createApi } from "@reduxjs/toolkit/query/react";
import fetchBaseQueryCSRF from "../helper";

const filters = createApi({
    baseQuery: fetchBaseQueryCSRF({ baseUrl: process.env.CROSS_API_URL }),
    reducerPath: 'api.filters',
    tagTypes: ['filters'],
    endpoints: (builder) => ({
        platforms: builder.query<any, {
            workspace: any
        }>({
            query: ({ workspace }) => {
                const url = `/filters/platforms`;
                const body = {
                    workspace
                };

                return {
                    url,
                    method: 'POST',
                    body: JSON.stringify(body),
                    headers: {
                        'Content-Type': 'application/json',
                        'Cache-Control': 'no-cache',
                        Accept: 'application/json',
                    },
                };
            },
        }),
        countries: builder.query<any, {
            workspace: any,
            platforms: any,
            startDate: any,
            endDate: any
        }>({
            query: ({ workspace, platforms, startDate, endDate }) => {
                const url = `/filters/countries`;
                const body = {
                    workspace,
                    platforms,
                    startDate,
                    endDate
                };

                return {
                    url,
                    method: 'POST',
                    body: JSON.stringify(body),
                    headers: {
                        'Content-Type': 'application/json',
                        'Cache-Control': 'no-cache',
                        Accept: 'application/json',
                    },
                };
            },
        }),
        countriesCoverage: builder.query<any, {
            workspace: any,
            platforms: any,
            devices: any,
            startDate: any,
            endDate: any
        }>({
            query: ({ workspace, platforms, devices, startDate, endDate }) => {
                const url = `/filters/countries-coverage`;
                const body = {
                    workspace,
                    platforms,
                    devices,
                    startDate,
                    endDate
                };

                return {
                    url,
                    method: 'POST',
                    body: JSON.stringify(body),
                    headers: {
                        'Content-Type': 'application/json',
                        'Cache-Control': 'no-cache',
                        Accept: 'application/json',
                    },
                };
            },
        }),
        geotargetsSearch: builder.query<any, {
            q: string,
            countryCodes?: string[]
        }>({
            query: ({ q, countryCodes }) => {
                const url = `/filters/geotargets`;
                // An empty scope is sent as such: the backend reads it as "no
                // restriction", which is what a workspace with no configured
                // country needs.
                const body = { q, country_codes: countryCodes || [] };

                return {
                    url,
                    method: 'POST',
                    body: JSON.stringify(body),
                    headers: {
                        'Content-Type': 'application/json',
                        'Cache-Control': 'no-cache',
                        Accept: 'application/json',
                    },
                };
            },
        }),
        geotargetsByIds: builder.query<any, {
            ids: number[]
        }>({
            query: ({ ids }) => {
                const url = `/filters/geotargets`;
                const body = { ids };

                return {
                    url,
                    method: 'POST',
                    body: JSON.stringify(body),
                    headers: {
                        'Content-Type': 'application/json',
                        'Cache-Control': 'no-cache',
                        Accept: 'application/json',
                    },
                };
            },
        }),
        searchTerms: builder.query<any, {
            workspace: any,
            platforms: any,
            devices: any,
            startDate: any,
            countries: any
            endDate: any
        }>({
            query: ({ workspace, platforms, startDate, endDate, devices, countries }) => {
                const url = `/filters/search-terms`;
                const body = {
                    workspace,
                    platforms,
                    devices,
                    startDate,
                    endDate,
                    countries,
                };

                return {
                    url,
                    method: 'POST',
                    body: JSON.stringify(body),
                    headers: {
                        'Content-Type': 'application/json',
                        'Cache-Control': 'no-cache',
                        Accept: 'application/json',
                    },
                };
            },
        }),
    }),
});

export const {
    usePlatformsQuery,
    useCountriesQuery,
    useCountriesCoverageQuery,
    useLazyGeotargetsSearchQuery,
    useGeotargetsByIdsQuery,
    useSearchTermsQuery
} = filters;

export default filters;
